import React from 'react'
import CreateArticleWorker from './create'
import { Link, withRouter } from 'react-router-dom'
import ArticleForm from '../components/form/form.component'
import FormHelper from '../../../../utils/FormHelper'
import './create.styles.scss'
import Dialog from '../../../../components/dialog/dialog.component'
import Loading from '../../../../components/loading/loading.component'

class CreateArticle extends React.Component {

    constructor(props) {
        super(props)
        this.createArticleWorker = CreateArticleWorker(this)
        this.state = this.createArticleWorker.getDefaultState()
    }

    componentDidMount(){
        this.createArticleWorker.loadArchives()
        this.createArticleWorker.loadArticleTypes()
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.createArticleWorker.isValid() && this.createArticleWorker.createArticle()
    }

    onCancel = () => this.props.history.push('/article/articles')

    render() {
        return (
            <div className="create-article">
                {
                    (this.state.loadingJournals || this.state.loadingTypes) && <Dialog><Loading /></Dialog>
                }
                <div className="card">
                    <Link className="btn" to="/article/articles">Articles</Link>
                    <div className="header">
                        <h4>Create Article</h4>
                    </div>
                    <div className={"flag " + this.state.flag.type}>
                        {this.state.flag.text}
                    </div>
                    <ArticleForm {...this.state} action="Add Article" onChange={FormHelper(this).onChange} onSubmit={this.onSubmit} onCancel={this.onCancel}/>
                </div>
            </div>
        )
    }
}

export default withRouter(CreateArticle)